module.exports = __webpack_public_path__ + "static/paris-0a68523c1a3e4197b90b62552fb98a9f.jpg";